import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { SYSTEMS_ROUTE } from 'constants/routeNames';
import './PageNotFound.scss';

const NotFound = () => {
  const { t } = useTranslation();
  const pathToReturn = SYSTEMS_ROUTE;
  return (
    <div className="notFount-container">
      <h1>{t('page-not-found.title')}</h1>
      <h3>{t('page-not-found.description')}</h3>
      <Link to={pathToReturn}>{t('general.return')}</Link>
    </div>
  );
};

export default NotFound;
